<template>
  <div class="user-list">
    <el-form
      :inline="true"
      class="demo-form-inline"
      :loading="loading"
      size="mini"
    >
      <!--<el-form-item>-->
      <!--<el-input v-model="search" placeholder="输入名字查询" size="small"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item>
        <el-button-group>
          <!--<el-button type="primary" @click="fetch" size="mini">查询</el-button>-->
          <el-button @click="post" size="mini">增加</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>

    <el-table :data="list" size="mini">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="角色名">
              <el-input v-model="props.row.roleName" size="mini" />
            </el-form-item>

            <el-form-item label="权限">
              <el-transfer
                :titles="['权限列表', '已有权限']"
                v-model="props.row.perm"
                :data="pers"
              ></el-transfer>
            </el-form-item>
            <el-form-item>
              <el-button @click="update(props.row)" size="mini" type="primary"
                >更新</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column
        prop="roleName"
        label="角色名"
        width="150px"
      ></el-table-column>

      <el-table-column label="权限">
        <template slot-scope="scope">
          <span
            v-for="item in scope.row.permissions"
            style="padding: 5px; display: inline-block"
          >
            <el-tag size="small">{{ item.name }}</el-tag></span
          >
        </template>
      </el-table-column>

      <el-table-column width="80px">
        <template slot-scope="scope">
          <el-button-group size="mini" label="操作">
            <el-button size="mini" type="danger" @click="remove(scope.row)"
              >删除</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div style="float: right">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="20"
        @current-change="(i) => (page = i)"
        :page-count="page"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "../request";
import map from "../../datamap";

const list = "/sysRole/listRoleWithPerm";

import api from "../api";
let { role, per } = api;

export default {
  name: "role-list",
  data() {
    return {
      loading: true,
      search: "",
      list: [],
      pers: [],
      user_map: map.user,
      total: 0,
      page: 1,
    };
  },
  watch: {
    page() {
      this.fetch();
    },
  },
  methods: {
    async fetch_perms() {
      let res = await per.list({
        start: 0,
        limit: 9999,
      });
      res = res.data.data.map(function (i) {
        i.key = i.id;
        i.label = i.name;
        return i;
      });
      this.pers = res;
    },

    async post() {
      let { value } = await this.$prompt("请输入角色名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      });

      let res = await api.role.post({ roleName: value, available: 1 });
      let {
        data: { data, code },
      } = res;
      if (code === 200) {
        this.$message.success("增加角色成功");
        this.fetch();
      }
    },

    async fetch() {
      let pageNum = this.page;
      let res = await role.list({ start: (pageNum - 1) * 20 });
      let list = res.data.data.map(function (item) {
        item.permissions = item.permissions || [];
        item.perm = item.permissions.map(function (o) {
          return o.id;
        });
        return item;
      });
      this.list = list;
      this.total = res.data.pageinfo.totalCount;
    },
    async update(obj) {
      obj.permIds = obj.perm.join(",");
      delete obj.available;
      delete obj.perm;
      delete obj.createTime;
      delete obj.updateTime;
      const res = await role.update(obj);
      if (res.data.code === 200) {
        this.$message.success("更新数据成功");
        this.fetch();
      } else if (res.data.code === 500) {
        this.$message.error("没有权限");
      }
    },
    async remove(obj) {
      try {
        await this.$confirm(" 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        obj.permId = "";
        let res = await role.remove(obj);
        let { code } = res.data;
        if (code === 200) {
          this.$message.success("删除角色成功");
        }
        this.fetch();
      } catch (e) {}
    },
  },
  mounted() {
    this.fetch();
    this.fetch_perms();
  },
};
</script>

<style>
.user-list {
}
</style>



// WEBPACK FOOTER //
// src/views/role/role-list.vue